import React, { useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import API from '@components/api';
import BasicNavMenu from '@components/Navbars/Basic';
import Textbox from '@controls/textbox';
import { useMounted } from '@modules/hooks';
import { REGEXES } from '@modules/validation';
import { globalActions } from '@reducers/global';
import MobileSidebar from '@views/Public/shared-content/mobile-sidebar';

const ResetPassword = props => {
	const dispatch = useDispatch(),
		support_student_id = useSelector(state => state.user.support_student_id),
		campus_admin = useSelector(state => state.user.campus_admin),
		captureError = err => dispatch(globalActions.captureError(err)),
		[email, setEmail] = useState(''),
		[resetState, setResetState] = useState(''),
		[error, setError] = useState(''),
		[working, setWorking] = useState(false),
		mounted = useMounted(),
		api = useMemo(() => new API('', support_student_id, campus_admin), [support_student_id, campus_admin]),
		allow_submit = !!email && REGEXES.email.test(email);

	function onSubmit() {
		setWorking(true);

		api.resetPassword(encodeURIComponent(email))
			.then(result => {
				if (mounted()) {
					if (result.result === 'success') {
						setWorking(false);
						setResetState('completed');
						setError(
							'Reset information will be sent to the email you provided if an account with that email is in our system.'
						);
					} else {
						setResetState('notCompleted');
						setError(`No account associated with this email: ${email}`);
					}
				}
			})
			.catch(ex => captureError(ex));
	}

	return (
		<div className='body-2' role='main'>
			<MobileSidebar />

			<div className='two-column-view' role='navigation'>
				<BasicNavMenu />

				<div className='right-column'>
					<div className='right-column-wrap'>
						<div className='form-block w-form'>
							<h1 className='column-heading'>Reset Password</h1>

							<form
								id='email-form'
								name='email-form'
								data-name='Email Form'
								className='form'
								onSubmit={e => {
									e.preventDefault();
									e.stopPropagation();

									if (allow_submit) onSubmit();
								}}>
								<p className='intro-copy'>
									Enter the email address associated with your Universities of Wisconsin account to
									have the password reset instructions emailed to you.
								</p>

								<Textbox
									type='email'
									name='email'
									value={email}
									maxLength={256}
									label='Email'
									placeholder='Enter your email or username'
									required={true}
									onChange={val => setEmail(val)}
									isInvalid={!REGEXES.email.test(email)}
								/>

								{!!error && <h4 className={`text ${resetState}`}>{error}</h4>}

								<input
									aria-label='Reset password submit'
									type='submit'
									value='Reset Password'
									data-wait='Please wait...'
									className='submit-button w-button'
									disabled={working || !allow_submit}
								/>
							</form>
						</div>
					</div>
				</div>
			</div>
			<script
				src='https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.4.1.min.220afd743d.js?site=5ea1ccd99c38e78f25db182e'
				type='text/javascript'
				integrity='sha256-CSXorXvZcTkaix6Yvo6HppcZGetbYMGWSFlBw8HfCJo='
				crossOrigin='anonymous'></script>
			<script src='@webflowJS/webflow.js' type='text/javascript'></script>
		</div>
	);
};

export default ResetPassword;
